import React, { useState } from "react";
import styles from "./dashboard.module.scss";
import DashboardStatus from "./dashboardStatus";
import {
  KoCharts,
  KoLoader,
  KoText,
  KoTitle
} from "packages";
import RevenueChartConfig from "./revenuechartconfig";
import TopProduct from "./topsales/topproduct";
import RecentProduct from "./topsales/recentproduct";
import TargetGaugeConfig from "./targets";

export default function Dashboard() {
  const [loading] = useState(false);
  const [selectedChart, setSelectedChart] = useState("revenue");

  const data = [
    { month: 'JAN', website: 1000, eCommerce: 90000, offline: 600 },
    { month: 'FEB', website: 1500, eCommerce: 110000, offline: 70000 },
    { month: 'MAR', website: 170000, eCommerce: 95000, offline: 80000 },
    { month: 'APR', website: 1000, eCommerce: 120, offline: 85000 },
    { month: 'MAY', website: 18000, eCommerce: 130000, offline: 90000 },
    { month: 'JUN', website: 20, eCommerce: 500, offline: 95000 },
    { month: 'DEC', website: 87500, eCommerce: 1110000, offline: 80000 },
    { month: 'NOV', website: 10000, eCommerce: 1410000, offline: 230000 }
  ];
  const tergetdata = { value: 70, amount: 12000 };

  const handleCardClick = (chartId) => {
    setSelectedChart(chartId);
  };

  const incomeTarget = {
    value: 66.6,
    amount: 75000,
    target: 125000,
    growthToday: 7.5,
    profitToday: 150,
    weekProfit: 1470
  };

  return (
    <div className={`${styles.wrapper} profileSection`}>
      {loading && <KoLoader />}
      <div className={styles.dashboardContiner}>
        <DashboardStatus onCardClick={handleCardClick} selectedChart={selectedChart} />
        <div className={styles.graphwapper}>
          <div className={styles.graph}  >
            <KoCharts option={RevenueChartConfig(data)} />;
          </div>
          <div className={styles.target}>

            <KoTitle className={styles.targetTitle} level={3} text={'Target'}/>
            <KoText className={styles.text} text={'Income target progress'}/>
            <KoCharts option={TargetGaugeConfig(tergetdata)} />

            <div style={{ textAlign: "center", marginTop: "-250px", display:"grid" }}>
              <KoText className={styles.text} text={`${incomeTarget.value}%`}/>
              <KoText className={styles.text} text={`${incomeTarget.growthToday}% ↑ +${incomeTarget.profitToday} Today`}/>
              <KoText className={styles.text} text={`Hooray 🎉 you earned ${incomeTarget.profitToday} today and ${incomeTarget.weekProfit} this week. Keep it up!`}/>
            </div>

            <div className={styles.bottomStauts}>
              <div>
                <KoText className={styles.text} text={'Achieved'}/>
                <KoTitle  text={`${incomeTarget.amount.toLocaleString()}`}/>
              </div>
              <div>
                <KoText className={styles.text} level={4} text={'Target'}/>
                <KoTitle  level={4} text={`${ incomeTarget.target.toLocaleString()}`}/>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.topProducts}>
          <TopProduct/>
        </div>
        <div  className={styles.productTable}>
          <RecentProduct/>
        </div>
      </div>
    </div>
  );
}
